import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

/**
 * Aviso único das telas do Configuration Server: uma mensagem e, quando há o
 * que repetir, um botão amarelo dentro da própria faixa. Substitui os vários
 * "Tentar novamente" soltos no canto da tela.
 */
export function ConfigServerAlert({
  message,
  detail,
  onRetry,
}: {
  message: string;
  detail?: string | null;
  onRetry?: () => void;
}) {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      className="flex flex-wrap items-center justify-between gap-3 rounded-md border border-red-200 bg-red-50 px-3.5 py-3"
    >
      <div className="flex min-w-0 items-start gap-2.5">
        <AlertTriangle aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-[#d93636]" />
        <div className="min-w-0 space-y-1">
          <p className="m-0 text-sm font-medium text-[#8f1f1f]">{message}</p>
          {detail && <p className="m-0 break-words font-mono text-[11px] leading-relaxed text-[#8f1f1f]/70">{detail}</p>}
        </div>
      </div>
      {onRetry && (
        <Button type="button" variant="action" size="sm" onClick={onRetry}>
          {t("Retry")}
        </Button>
      )}
    </div>
  );
}
